/* eslint-disable prefer-const */
import axios, { AxiosRequestConfig } from 'axios';
import * as rdd from 'react-device-detect';
import { setupAxios } from '@carvana/core-auth';

const isLocalEnvironment: boolean =
  process.env.CARVANA_APP_IS_LOCAL_ENVIRONMENT === 'true' || false;

export function validateAuthResponse(isLoggedOut: boolean) {
  // if a user is authenticated and is requesting /my-cars/ allow user to login using
  // account modal instead of redirecting home.

  // check pathname for /my-cars
  const urlPath = window.location.pathname;
  const isMyCarsPath = urlPath.indexOf('/my-cars') >= 0;

  // we need to know if the user already has appended
  // the account modal signin OR if the modal is already open
  const queryString = window.location.search;
  const parameters = new URLSearchParams(queryString);

  // if this is present the modal is either open or the query param is already
  // appended to the url
  const isLoginModalOpen = parameters.has('openAccountModal');

  // check all flags
  const shouldPromptLogin =
    isLoggedOut && !isLocalEnvironment && isMyCarsPath && !isLoginModalOpen;

  if (shouldPromptLogin) {
    window.location.search = '?openAccountModal=siginin';
  }
}

const createAxiosInstance = ({ timeout = 10000, ...rest }) => {
  const instance: any = axios.create({
    timeout,
    ...rest,
  });

  instance.interceptors.request.use(async (config: AxiosRequestConfig) => {
    const originalConfig = config;

    originalConfig.headers['Access-Control-Allow-Origin'] = '*';
    originalConfig.headers['Access-Control-Allow-Methods'] =
      'DELETE, POST, GET, OPTIONS';
    originalConfig.headers['X-CVNA-Platform'] = rdd.osName;
    originalConfig.headers['X-CVNA-AppVersion'] = rdd.osVersion;
    originalConfig.headers['X-CVNA-DeviceType'] = rdd.deviceType;
    originalConfig.headers['X-CVNA-DeviceId'] = rdd.isMobile
      ? rdd.mobileModel
      : rdd.browserName;

    return originalConfig;
  });

  return setupAxios(instance, { addBearerTokenToAllRequests: true });
};

const axiosWithAuth = (options = {}) => createAxiosInstance(options);

export default axiosWithAuth;
